export const MS_IN_MINUTE = 1000 * 60;
export const MS_IN_HOUR = 1000 * 60 * 60;
export const MS_IN_DAY = 1000 * 60 * 60 * 24;
export const ACTIVATION_DAYS_COUNT = 30;
export const PULL_TO_REFRESH_TIME_COUNT = 2000;
